export const AgentEnquiringData = [
  {
    key: "1",
    type: "Hotel",
    enquiryfor: "Vivanta",
    customerinfo: "Adrian Markel",
    status: "Pending",
    inquiredOn: "15 May 2025",
  },
  {
    key: "2",
    type: "Cars",
    enquiryfor: "Toyota Camry SE 400",
    customerinfo: "Timothy Brewer",
    status: "Completed",
    inquiredOn: "15 May 2025",
  },
  {
    key: "3",
    type: "Flight",
    enquiryfor: "SkyBound 102",
    customerinfo: "Mark Arrington",
    status: "Completed",
    inquiredOn: "15 May 2025",
  },
  {
    key: "4",
    type: "Cruise",
    enquiryfor: "Super Aquamarine",
    customerinfo: "Kenneth Palmer",
    status: "Completed",
    inquiredOn: "15 May 2025",
  },
  {
    key: "5",
    type: "Tours",
    enquiryfor: "PlayPalooza Part",
    customerinfo: "Ronald Moultrie",
    status: "Completed",
    inquiredOn: "15 May 2025",
  },


];
